export default "__VITE_ASSET__BURNY1Vn__"